import SuspenseLoader from 'components/SuspenseLoader';
import { ComponentType, lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

const Loader = (Component: ComponentType) => {
  const WithSuspense = (props: object) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  WithSuspense.displayName = 'WithSuspense';
  return WithSuspense;
};

// Dashboards

const Automation = Loader(lazy(() => import('content/dashboards/Automation')));
const Analytics = Loader(lazy(() => import('content/dashboards/Analytics')));
const Reports = Loader(lazy(() => import('content/dashboards/Reports')));
const Banking = Loader(lazy(() => import('content/dashboards/Banking')));
const Commerce = Loader(lazy(() => import('content/dashboards/Commerce')));
const Expenses = Loader(lazy(() => import('content/dashboards/Expenses')));
const Crypto = Loader(lazy(() => import('content/dashboards/Crypto')));
const Finance = Loader(lazy(() => import('content/dashboards/Finance')));
const Fitness = Loader(lazy(() => import('content/dashboards/Fitness')));
const HealthcareDoctor = Loader(
  lazy(() => import('content/dashboards/Healthcare'))
);
const HealthcareHospital = Loader(
  lazy(() => import('content/dashboards/Healthcare/HospitalView'))
);
const Helpdesk = Loader(lazy(() => import('content/dashboards/Helpdesk')));
const Learning = Loader(lazy(() => import('content/dashboards/Learning')));
const Monitoring = Loader(lazy(() => import('content/dashboards/Monitoring')));
const Products = Loader(lazy(() => import('content/dashboards/Products')));
const Statistics = Loader(lazy(() => import('content/dashboards/Statistics')));
const Tasks = Loader(lazy(() => import('content/dashboards/Tasks')));

const dashboardsRoutes = [
  {
    path: '',
    element: <Analytics />
  },
  {
    path: 'automation',
    element: <Automation />
  },
  {
    path: 'analytics',
    element: <Analytics />
  },
  {
    path: 'reports',
    element: <Reports />
  },
  {
    path: 'banking',
    element: <Banking />
  },
  {
    path: 'commerce',
    element: <Commerce />
  },
  {
    path: 'expenses',
    element: <Expenses />
  },
  {
    path: 'crypto',
    element: <Crypto />
  },
  {
    path: 'finance',
    element: <Finance />
  },
  {
    path: 'fitness',
    element: <Fitness />
  },
  {
    path: 'healthcare',
    children: [
      {
        path: '',
        element: <Navigate to="hospital" replace />
      },
      {
        path: 'hospital',
        element: <HealthcareHospital />
      },
      {
        path: 'doctor',
        element: <HealthcareDoctor />
      }
    ]
  },
  {
    path: 'helpdesk',
    element: <Helpdesk />
  },
  {
    path: 'learning',
    element: <Learning />
  },
  {
    path: 'monitoring',
    element: <Monitoring />
  },
  {
    path: 'products',
    element: <Products />
  },
  {
    path: 'statistics',
    element: <Statistics />
  },
  {
    path: 'tasks',
    element: <Tasks />
  }
];

export default dashboardsRoutes;
